import { useAPIExplorer } from "../../APIExplorerContext"
import { RequestFormInput } from "./RequestFormInput"

/**
 * Display a fieldset managing a request pagination settings.
 */
export function RequestPaginationFieldset() {
  const { request } = useAPIExplorer()

  function setPage(page: string) {
    request.setPagination({
      ...request.pagination,
      page: page ? Math.max(1, parseInt(page)) : undefined,
    })
  }

  function setPageSize(pageSize: string) {
    request.setPagination({
      ...request.pagination,
      pageSize: pageSize
        ? Math.min(Math.max(1, parseInt(pageSize)), 100)
        : undefined,
    })
  }

  return (
    <>
      <RequestFormInput
        type="number"
        value={request.pagination.page?.toString() ?? ""}
        onValueChange={setPage}
        label="PAGE"
        placeholder="1"
      />
      <RequestFormInput
        type="number"
        value={request.pagination.pageSize?.toString() ?? ""}
        onValueChange={setPageSize}
        label="PAGE SIZE"
        placeholder="20"
      />
    </>
  )
}
